import { apiClient, ApiName } from '@shared/services/api'

export const fetchAlertMessage = () => {
  return apiClient.get(ApiName.CONFIGS, 'messages/alert')
}

export const updateAlertMessage = (data) => {
  return apiClient.patch(ApiName.ADMINS, 'super/messages/alert', data)
}
